import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import axios from 'axios';

class Relay {
  constructor(url) {
    _defineProperty(this, "url", void 0);

    this.url = url;
  }

  transport(_ref) {
    let {
      payload,
      headers,
      success,
      failure
    } = _ref;
    this.request({
      payload,
      headers
    }).then(success).catch(failure);
  }

  request(_ref2) {
    let {
      payload,
      headers
    } = _ref2;
    return axios.post(this.url, payload, {
      headers
    });
  }

}

export default Relay;